<template>
  <div
    class="text-ld-brand-500 bg-ld-brand-200 rounded-4px text-13px leading-[1.5] font-semibold py-2px px-6px"
  >
    {{ _t('cardview.new_knowledge') }}
  </div>
</template>
<script setup lang="ts"></script>
<style scoped></style>
